<template>
  <div class="score-container">
    <!--<h1>成绩列表</h1>-->
    <div class="result">
      <el-row>
        <el-col :span="2"><h4>比赛结果</h4></el-col>
        <el-col :span="6"><el-button style="position: relative;top: 12px;" type="primary" @click="handleExport">下载记录表</el-button></el-col>
      </el-row>
      <el-row>
        <el-table
          :data="gameResult"
          border
          style="width: 601px;float: left;">
          <el-table-column
            prop="name"
            label="球队"
            width="120"/>
          <el-table-column
            prop="first"
            label="第一局"
            width="80"/>
          <el-table-column
            prop="second"
            label="第二局"
            width="80"/>
          <el-table-column
            prop="third"
            label="第三局"
            width="80"/>
          <el-table-column
            prop="four"
            label="加时赛"
            width="80"/>
          <el-table-column
            prop="five"
            label="射门比赛"
            width="80"/>
          <el-table-column
            prop="total"
            label="合计"
            width="80"/>
        </el-table>
        <div class="qiquanBox">
          <el-checkbox v-model="qiquan" @change="handleQiquanChange">是否弃权</el-checkbox>
          <el-checkbox v-model="jiashi" @change="handleQiquanChange">是否加时赛</el-checkbox>
          <el-row v-if="qiquan">
            <div class="title">主队得分</div>
            <el-input v-model="gameScore.homeScore" placeholder="主队成绩" style="width: 90px;" @change="handleQiquanChange"/>
          </el-row>
          <el-row v-if="qiquan">
            <div class="title">客队得分</div>
            <el-input v-model="gameScore.awayScore" placeholder="客队成绩" style="width: 90px;" @change="handleQiquanChange"/>
          </el-row>
        </div>
      </el-row>
    </div>
    <!-- 主队录入 start -->
    <div class="team-score">
      <div class="team-list">
        <h3 style="display: inline-block;">主队名称：{{ gameScore.homeTeam && gameScore.homeTeam.name }}</h3>
        <el-button style="width: 80px; float: right; margin-top: 15px" type="primary" @click="saveHomeTeam">保 存</el-button>
        <el-table
          :data="homePlayers"
          border
          style="width: 100%">
          <el-table-column
            label="序号">
            <template slot-scope="scope" >
              <div>{{ scope.$index+1 }}{{ scope.row.position=='守门员'?' G':'' }}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="trueName"
            label="姓名"/>
          <el-table-column
            prop="jerseyNo"
            label="号码"/>
          <el-table-column
            prop="position"
            label="位置"/>
          <el-table-column
            label="最佳球员">
            <template slot-scope="scope">
              <el-checkbox-button v-model="scope.row.mvp" :disabled="!scope.row.status" label="全场最佳" @change="mvpChange('home', scope.$index , scope.row)"/>
            </template>
          </el-table-column>
          <el-table-column
            label="检录状态">
            <template slot-scope="{ row }">
              <el-button v-if="row.status" type="success" icon="el-icon-check" @click="statusChange(row)">已检录</el-button>
              <el-button v-else type="warning" icon="el-icon-warning" @click="statusChange(row)">待检录</el-button>
            </template>
          </el-table-column>
          <el-table-column
            label="队长"/>
        </el-table>
      </div>
      <!-- 射中记录 start -->
      <div class="team-action" style="width: 400px">
        <h3>射中记录</h3>
        <div class="action">
          <el-button @click="handleGoalAdd(true)">添加</el-button>
          <el-button @click="handleGoalActionSave(true)">保存</el-button>
          <el-button @click="handleGoalDelete(true)">删除</el-button>
        </div>
        <el-table
          :data="homeGoals"
          border
          style="width: 391px"
          @row-click="onEdit"
          @selection-change="handleHomeGoalSelectionChange">
          <el-table-column
            type="selection"
            width="35"/>
          <el-table-column
            width="40"
            label="序号">
            <template slot-scope="scope">
              <label>{{ scope.$index+1 }}</label>
            </template>
          </el-table-column>
          <el-table-column
            width="60"
            label="时间">
            <template slot-scope="scope">
              <el-input v-if="scope.row.isEdit" v-model="scope.row.time" @keyup.enter.native="onGoalSubmit(scope.row)"/>
              <label v-if="!scope.row.isEdit">{{ scope.row.time }}</label>
            </template>
          </el-table-column>
          <el-table-column
            width="50"
            label="射中">
            <template slot-scope="scope">
              <el-input v-if="scope.row.isEdit" v-model="scope.row.player" @keyup.enter.native="onGoalSubmit(scope.row)"/>
              <label v-if="!scope.row.isEdit">{{ scope.row.player }}</label>
            </template>
          </el-table-column>
          <el-table-column
            width="50"
            label="一助">
            <template slot-scope="scope">
              <el-input v-if="scope.row.isEdit" v-model="scope.row.other1" @keyup.enter.native="onGoalSubmit(scope.row)"/>
              <label v-if="!scope.row.isEdit">{{ scope.row.other1 }}</label>
            </template>
          </el-table-column>
          <el-table-column
            width="50"
            label="二助">
            <template slot-scope="scope">
              <el-input v-if="scope.row.isEdit" v-model="scope.row.other2" @keyup.enter.native="onGoalSubmit(scope.row)"/>
              <label v-if="!scope.row.isEdit">{{ scope.row.other2 }}</label>
            </template>
          </el-table-column>
          <el-table-column
            width="50"
            label="守门员">
            <template slot-scope="scope">
              <el-input v-if="scope.row.isEdit" v-model="scope.row.goalkeeper" @keyup.enter.native="onGoalSubmit(scope.row)"/>
              <label v-if="!scope.row.isEdit">{{ scope.row.goalkeeper }}</label>
            </template>
          </el-table-column>
          <el-table-column
            width="55"
            label="对阵">
            <template slot-scope="scope">
              <el-select v-model="scope.row.duizhen" placeholder="请选择" @change="vsChange(scope.row)">
                <el-option
                  v-for="item in ['EN', 'EQ', '+1', '+2', '-1', '-2', 'PS', 'GWG']"
                  :key="item"
                  :label="item"
                  :value="item"/>
              </el-select>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 射中记录 end -->

      <!-- 判罚记录 start -->
      <div class="team-action" style="width: 345px">
        <h3>判罚记录</h3>
        <div class="action">
          <el-button @click="handlePenaltyAdd(true)">添加</el-button>
          <el-button @click="handlePenaltyActionSave(true)">保存</el-button>
          <el-button @click="handlePenaltyDelete(true)">删除</el-button>
        </div>
        <el-table
          :data="homePenalty"
          border
          style="width: 336px"
          @row-click="onEdit"
          @selection-change="handleHomePenaltySelectionChange">
          <el-table-column
            type="selection"
            width="35"/>
          <el-table-column
            width="40"
            label="序号">
            <template slot-scope="scope">
              <label>{{ scope.$index+1 }}</label>
            </template>
          </el-table-column>
          <el-table-column
            width="60"
            label="号码">
            <template slot-scope="scope">
              <el-input v-if="scope.row.isEdit" v-model="scope.row.player" @keyup.enter.native="onPenaltySubmit(scope.row)"/>
              <label v-if="!scope.row.isEdit">{{ scope.row.player }}</label>
            </template>
          </el-table-column>
          <el-table-column
            width="50"
            label="分钟">
            <template slot-scope="scope">
              <el-input v-if="scope.row.isEdit" v-model="scope.row.minutes" @keyup.enter.native="onPenaltySubmit(scope.row)"/>
              <label v-if="!scope.row.isEdit">{{ scope.row.minutes }}</label>
            </template>
          </el-table-column>
          <el-table-column
            width="50"
            label="类别">
            <template slot-scope="scope">
              <el-input v-if="scope.row.isEdit" v-model="scope.row.type" @keyup.enter.native="onPenaltySubmit(scope.row)"/>
              <label v-if="!scope.row.isEdit">{{ scope.row.type }}</label>
            </template>
          </el-table-column>
          <el-table-column
            width="50"
            label="开始">
            <template slot-scope="scope">
              <el-input v-if="scope.row.isEdit" v-model="scope.row.begin" @keyup.enter.native="onPenaltySubmit(scope.row)"/>
              <label v-if="!scope.row.isEdit">{{ scope.row.begin }}</label>
            </template>
          </el-table-column>
          <el-table-column
            width="50"
            label="结束">
            <template slot-scope="scope">
              <el-input v-if="scope.row.isEdit" v-model="scope.row.end" @keyup.enter.native="onPenaltySubmit(scope.row)"/>
              <label v-if="!scope.row.isEdit">{{ scope.row.end }}</label>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 判罚记录 end -->

      <!-- 射门比赛 start -->
      <div class="team-action" style="width: 326px">
        <h3>射门比赛</h3>
        <div class="action">
          <el-button @click="handleShootAdd(true)">添加</el-button>
          <el-button @click="handleShootActionSave(true)">保存</el-button>
          <el-button @click="handleShootDelete(true)">删除</el-button>
        </div>
        <el-table
          ref="shootTable"
          :data="homeShoot"
          border
          style="width: 316px"
          @row-click="onEdit"
          @selection-change="handleHomeShootSelectionChange">
          <el-table-column
            type="selection"
            width="35"/>
          <el-table-column
            width="40"
            label="序号">
            <template slot-scope="scope">
              <label>{{ scope.$index+1 }}</label>
            </template>
          </el-table-column>
          <el-table-column
            width="60"
            label="号码">
            <template slot-scope="scope">
              <el-input v-if="scope.row.isEdit" v-model="scope.row.player" @keyup.enter.native="onShootSubmit(scope.row)"/>
              <label v-if="!scope.row.isEdit">{{ scope.row.player }}</label>
            </template>
          </el-table-column>
          <el-table-column
            width="75"
            label="对方守门员">
            <template slot-scope="scope">
              <el-input v-if="scope.row.isEdit" v-model="scope.row.goalkeeper" @keyup.enter.native="onShootSubmit(scope.row)"/>
              <label v-if="!scope.row.isEdit">{{ scope.row.goalkeeper }}</label>
            </template>
          </el-table-column>
          <el-table-column
            width="55"
            label="结果">
            <template slot-scope="scope">
              <el-select v-model="scope.row.goal" placeholder="请选择" @change="vsShootChange(scope.row)">
                <el-option
                  v-for="item in [{id: 1, name: '射中'}, {id: 0, name: '未中'}]"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"/>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
            width="50"
            label="制胜">
            <template slot-scope="scope">
              <el-select v-model="scope.row.win" placeholder="请选择" @change="vsShootChange(scope.row)">
                <el-option
                  v-for="item in [{id: 1, name: '是'}, {id: 0, name: '否'}]"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"/>
              </el-select>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 射门比赛 end -->
    </div><!-- 主队录入 end  -->
    <div style="clear: both"/>
    <!-- 客队录入 start -->
    <div class="team-score">
      <div class="team-list">
        <h3 style="display: inline-block">客队名称：{{ gameScore.awayTeam && gameScore.awayTeam.name }}</h3>
        <el-button style="width: 80px; float: right; margin-top: 15px" type="primary" @click="saveAwayTeam">保 存</el-button>
        <el-table
          :data="awayPlayers"
          border
          style="width: 100%">
          <el-table-column
            label="序号">
            <template slot-scope="scope" >
              <div>{{ scope.$index+1 }}{{ scope.row.position=='守门员'?' G':'' }}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="trueName"
            label="姓名"/>
          <el-table-column
            prop="jerseyNo"
            label="号码"/>
          <el-table-column
            prop="position"
            label="位置"/>
          <el-table-column
            label="最佳球员">
            <template slot-scope="scope">
              <el-checkbox-button v-model="scope.row.mvp" :disabled="!scope.row.status" label="全场最佳" @change="mvpChange('away', scope.$index)"/>
            </template>
          </el-table-column>
          <el-table-column
            label="检录状态">
            <template slot-scope="{ row }">
              <el-button v-if="row.status" type="success" icon="el-icon-check" @click="statusChange(row)">已检录</el-button>
              <el-button v-else type="warning" icon="el-icon-warning" @click="statusChange(row)">待检录</el-button>
            </template>
          </el-table-column>
          <el-table-column
            label="队长"/>
        </el-table>
      </div>
      <!-- 射中记录 start -->
      <div class="team-action" style="width: 400px">
        <h3>射中记录</h3>
        <div class="action">
          <el-button @click="handleGoalAdd()">添加</el-button>
          <el-button @click="handleGoalActionSave()">保存</el-button>
          <el-button @click="handleGoalDelete()">删除</el-button>
        </div>
        <el-table
          :data="awayGoals"
          border
          style="width: 391px"
          @row-click="onEdit"
          @selection-change="handleAwayGoalSelectionChange">
          <el-table-column
            type="selection"
            width="35"/>
          <el-table-column
            width="40"
            label="序号">
            <template slot-scope="scope">
              <label>{{ scope.$index+1 }}</label>
            </template>
          </el-table-column>
          <el-table-column
            width="60"
            label="时间">
            <template slot-scope="scope">
              <el-input v-if="scope.row.isEdit" v-model="scope.row.time" @keyup.enter.native="onGoalSubmit(scope.row)"/>
              <label v-if="!scope.row.isEdit">{{ scope.row.time }}</label>
            </template>
          </el-table-column>
          <el-table-column
            width="50"
            label="射中">
            <template slot-scope="scope">
              <el-input v-if="scope.row.isEdit" v-model="scope.row.player" @keyup.enter.native="onGoalSubmit(scope.row)"/>
              <label v-if="!scope.row.isEdit">{{ scope.row.player }}</label>
            </template>
          </el-table-column>
          <el-table-column
            width="50"
            label="一助">
            <template slot-scope="scope">
              <el-input v-if="scope.row.isEdit" v-model="scope.row.other1" @keyup.enter.native="onGoalSubmit(scope.row)"/>
              <label v-if="!scope.row.isEdit">{{ scope.row.other1 }}</label>
            </template>
          </el-table-column>
          <el-table-column
            width="50"
            label="二助">
            <template slot-scope="scope">
              <el-input v-if="scope.row.isEdit" v-model="scope.row.other2" @keyup.enter.native="onGoalSubmit(scope.row)"/>
              <label v-if="!scope.row.isEdit">{{ scope.row.other2 }}</label>
            </template>
          </el-table-column>
          <el-table-column
            width="50"
            label="守门员">
            <template slot-scope="scope">
              <el-input v-if="scope.row.isEdit" v-model="scope.row.goalkeeper" @keyup.enter.native="onGoalSubmit(scope.row)"/>
              <label v-if="!scope.row.isEdit">{{ scope.row.goalkeeper }}</label>
            </template>
          </el-table-column>
          <el-table-column
            width="55"
            label="对阵">
            <template slot-scope="scope">
              <el-select v-model="scope.row.duizhen" placeholder="请选择" @change="vsChange(scope.row)">
                <el-option
                  v-for="item in ['EN', 'EQ', '+1', '+2', '-1', '-2', 'PS', 'GWG']"
                  :key="item"
                  :label="item"
                  :value="item"/>
              </el-select>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 射中记录 end -->

      <!-- 判罚记录 start -->
      <div class="team-action" style="width: 345px">
        <h3>判罚记录</h3>
        <div class="action">
          <el-button @click="handlePenaltyAdd()">添加</el-button>
          <el-button @click="handlePenaltyActionSave()">保存</el-button>
          <el-button @click="handlePenaltyDelete()">删除</el-button>
        </div>
        <el-table
          :data="awayPenalty"
          border
          style="width: 336px"
          @row-click="onEdit"
          @selection-change="handleAwayPenaltySelectionChange">
          <el-table-column
            type="selection"
            width="35"/>
          <el-table-column
            width="40"
            label="序号">
            <template slot-scope="scope">
              <label>{{ scope.$index+1 }}</label>
            </template>
          </el-table-column>
          <el-table-column
            width="60"
            label="号码">
            <template slot-scope="scope">
              <el-input v-if="scope.row.isEdit" v-model="scope.row.player" @keyup.enter.native="onPenaltySubmit(scope.row)"/>
              <label v-if="!scope.row.isEdit">{{ scope.row.player }}</label>
            </template>
          </el-table-column>
          <el-table-column
            width="50"
            label="分钟">
            <template slot-scope="scope">
              <el-input v-if="scope.row.isEdit" v-model="scope.row.minutes" @keyup.enter.native="onPenaltySubmit(scope.row)"/>
              <label v-if="!scope.row.isEdit">{{ scope.row.minutes }}</label>
            </template>
          </el-table-column>
          <el-table-column
            width="50"
            label="类别">
            <template slot-scope="scope">
              <el-input v-if="scope.row.isEdit" v-model="scope.row.type" @keyup.enter.native="onPenaltySubmit(scope.row)"/>
              <label v-if="!scope.row.isEdit">{{ scope.row.type }}</label>
            </template>
          </el-table-column>
          <el-table-column
            width="50"
            label="开始">
            <template slot-scope="scope">
              <el-input v-if="scope.row.isEdit" v-model="scope.row.begin" @keyup.enter.native="onPenaltySubmit(scope.row)"/>
              <label v-if="!scope.row.isEdit">{{ scope.row.begin }}</label>
            </template>
          </el-table-column>
          <el-table-column
            width="50"
            label="结束">
            <template slot-scope="scope">
              <el-input v-if="scope.row.isEdit" v-model="scope.row.end" @keyup.enter.native="onPenaltySubmit(scope.row)"/>
              <label v-if="!scope.row.isEdit">{{ scope.row.end }}</label>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 判罚记录 end -->

      <!-- 射门比赛 start -->
      <div class="team-action" style="width: 326px">
        <h3>射门比赛</h3>
        <div class="action">
          <el-button @click="handleShootAdd()">添加</el-button>
          <el-button @click="handleShootActionSave()">保存</el-button>
          <el-button @click="handleShootDelete()">删除</el-button>
        </div>
        <el-table
          ref="shootTable"
          :data="awayShoot"
          border
          style="width: 316px"
          @row-click="onEdit"
          @selection-change="handleAwayShootSelectionChange">
          <el-table-column
            type="selection"
            width="35"/>
          <el-table-column
            width="40"
            label="序号">
            <template slot-scope="scope">
              <label>{{ scope.$index+1 }}</label>
            </template>
          </el-table-column>
          <el-table-column
            width="60"
            label="号码">
            <template slot-scope="scope">
              <el-input v-if="scope.row.isEdit" v-model="scope.row.player" @keyup.enter.native="onShootSubmit(scope.row)"/>
              <label v-if="!scope.row.isEdit">{{ scope.row.player }}</label>
            </template>
          </el-table-column>
          <el-table-column
            width="75"
            label="对方守门员">
            <template slot-scope="scope">
              <el-input v-if="scope.row.isEdit" v-model="scope.row.goalkeeper" @keyup.enter.native="onShootSubmit(scope.row)"/>
              <label v-if="!scope.row.isEdit">{{ scope.row.goalkeeper }}</label>
            </template>
          </el-table-column>
          <el-table-column
            width="55"
            label="结果">
            <template slot-scope="scope">
              <el-select v-model="scope.row.goal" placeholder="请选择" @change="vsShootChange(scope.row)">
                <el-option
                  v-for="item in [{id: 1, name: '射中'}, {id: 0, name: '未中'}]"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"/>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
            width="50"
            label="制胜">
            <template slot-scope="scope">
              <el-select v-model="scope.row.win" placeholder="请选择" @change="vsShootChange(scope.row)">
                <el-option
                  v-for="item in [{id: 1, name: '是'}, {id: 0, name: '否'}]"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"/>
              </el-select>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 射门比赛 end -->
    </div><!-- 客队录入 end  -->
    <div style="clear: both"/>
    <div>
    <!-- 守门员上场时间 start -->
      <div class="team-action" style="width: 400px">
        <h3>守门员上场时间</h3>
        <div class="action">
          <el-button @click="handleGoalieTimeAdd()">添加</el-button>
          <el-button @click="handleGoalieTimeDelete()">删除</el-button>
        </div>
        <el-table
          :data="goalieTimes"
          border
          style="width: 396px"
          @row-click="onEdit"
          @selection-change="handleGoalieTimeSelectionChange">
          <el-table-column
            type="selection"
            width="35"/>
          <el-table-column
            width="40"
            label="序号">
            <template slot-scope="scope">
              <label>{{ scope.$index+1 }}</label>
            </template>
          </el-table-column>
          <el-table-column
            width="120"
            label="时间（格式00:00）">
            <template slot-scope="scope">
              <el-input v-if="scope.row.isEdit" v-model="scope.row.time" @keyup.native="onGoalieTimeSubmit(scope.row)" @keyup.enter.native="scope.row.isEdit=false"/>
              <label v-if="!scope.row.isEdit">{{ scope.row.time }}</label>
            </template>
          </el-table-column>
          <el-table-column
            width="100"
            label="主队">
            <template slot-scope="scope">
              <el-input v-if="scope.row.isEdit" v-model="scope.row.homePlayer" @keyup.native="onGoalieTimeSubmit(scope.row)" @keyup.enter.native="scope.row.isEdit=false"/>
              <label v-if="!scope.row.isEdit">{{ scope.row.homePlayer }}</label>
            </template>
          </el-table-column>
          <el-table-column
            width="100"
            label="客队">
            <template slot-scope="scope">
              <el-input v-if="scope.row.isEdit" v-model="scope.row.awayPlayer" @keyup.native="onGoalieTimeSubmit(scope.row)" @keyup.enter.native="scope.row.isEdit=false"/>
              <label v-if="!scope.row.isEdit">{{ scope.row.awayPlayer }}</label>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 射中记录 end -->
    </div>
    <div style="clear: both"/>
    <!-- 裁判管理 start -->
    <div class="referee-box">
      <h3>裁判记录</h3>
      <div class="action">
        <el-button @click="refereeActionSave()">保存</el-button>
      </div>
      <el-row>
        <el-col :span="4">
          <span class="title">比赛监督</span>
          <el-select v-model="office.supervisor" :disabled="!canUpdateOffice && !(!office.supervisor && canAddOffice)" filterable clearable placeholder="请选择" >
            <el-option
              v-for="item in outRefereeList"
              :key="item.id"
              :label="item.trueName"
              :value="item.id"/>
          </el-select>
        </el-col>
        <el-col :span="4">
          <span class="title">主裁1</span>
          <el-select v-model="office.mainReferee1" :disabled="!canUpdateOffice && !(!office.mainReferee1 && canAddOffice)" filterable clearable placeholder="请选择">
            <el-option
              v-for="item in refereeList"
              :key="item.id"
              :label="item.trueName"
              :value="item.id"/>
          </el-select>
        </el-col>
        <el-col :span="4">
          <span class="title">主裁2</span>
          <el-select v-model="office.mainReferee2" :disabled="!canUpdateOffice && !(!office.mainReferee2 && canAddOffice)" filterable clearable placeholder="请选择">
            <el-option
              v-for="item in refereeList"
              :key="item.id"
              :label="item.trueName"
              :value="item.id"/>
          </el-select>
        </el-col>
        <el-col :span="4">
          <span class="title">边裁1</span>
          <el-select v-model="office.linesman1" :disabled="!canUpdateOffice && !(!office.linesman1 && canAddOffice)" filterable clearable placeholder="请选择">
            <el-option
              v-for="item in refereeList"
              :key="item.id"
              :label="item.trueName"
              :value="item.id"/>
          </el-select>
        </el-col>
        <el-col :span="4">
          <span class="title">边裁2</span>
          <el-select v-model="office.linesman2" :disabled="!canUpdateOffice && !(!office.linesman2 && canAddOffice)" filterable clearable placeholder="请选择">
            <el-option
              v-for="item in refereeList"
              :key="item.id"
              :label="item.trueName"
              :value="item.id"/>
          </el-select>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="4">
          <span class="title">裁判监督</span>
          <el-select v-model="office.refereeSupervisor" :disabled="!canUpdateOffice && !(!office.refereeSupervisor && canAddOffice)" filterable clearable placeholder="请选择">
            <el-option
              v-for="item in refereeList"
              :key="item.id"
              :label="item.trueName"
              :value="item.id"/>
          </el-select>
        </el-col>
        <el-col :span="4">
          <span class="title">计时</span>
          <el-select v-model="office.timer" :disabled="!canUpdateOffice && !(!office.timer && canAddOffice)" filterable clearable placeholder="请选择">
            <el-option
              v-for="item in outRefereeList"
              :key="item.id"
              :label="item.trueName"
              :value="item.id"/>
          </el-select>
        </el-col>
        <el-col :span="4">
          <span class="title">记录</span>
          <el-select v-model="office.recorder" :disabled="!canUpdateOffice && !(!office.recorder && canAddOffice)" filterable clearable placeholder="请选择">
            <el-option
              v-for="item in outRefereeList"
              :key="item.id"
              :label="item.trueName"
              :value="item.id"/>
          </el-select>
        </el-col>
        <el-col :span="4">
          <span class="title">宣告</span>
          <el-select v-model="office.announcer" :disabled="!canUpdateOffice && !(!office.announcer && canAddOffice)" filterable clearable placeholder="请选择">
            <el-option
              v-for="item in outRefereeList"
              :key="item.id"
              :label="item.trueName"
              :value="item.id"/>
          </el-select>
        </el-col>
        <el-col :span="4">
          <span class="title">记罚</span>
          <el-select v-model="office.refereeRecorder1" :disabled="!canUpdateOffice && !(!office.refereeRecorder1 && canAddOffice)" filterable clearable placeholder="请选择">
            <el-option
              v-for="item in outRefereeList"
              :key="item.id"
              :label="item.trueName"
              :value="item.id"/>
          </el-select>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="4">
          <span class="title">助理1</span>
          <el-select v-model="office.assist1" :disabled="!canUpdateOffice && !(!office.assist1 && canAddOffice)" filterable clearable placeholder="请选择">
            <el-option
              v-for="item in outRefereeList"
              :key="item.id"
              :label="item.trueName"
              :value="item.id"/>
          </el-select>
        </el-col>
        <el-col :span="4">
          <span class="title">助理2</span>
          <el-select v-model="office.assist2" :disabled="!canUpdateOffice && !(!office.assist2 && canAddOffice)" filterable clearable placeholder="请选择">
            <el-option
              v-for="item in outRefereeList"
              :key="item.id"
              :label="item.trueName"
              :value="item.id"/>
          </el-select>
        </el-col>
        <el-col :span="4">
          <span class="title">助理3</span>
          <el-select v-model="office.assist3" :disabled="!canUpdateOffice && !(!office.assist3 && canAddOffice)" filterable clearable placeholder="请选择">
            <el-option
              v-for="item in outRefereeList"
              :key="item.id"
              :label="item.trueName"
              :value="item.id"/>
          </el-select>
        </el-col>
        <el-col :span="4">
          <span class="title">记罚</span>
          <el-select v-model="office.refereeRecorder2" :disabled="!canUpdateOffice && !(!office.refereeRecorder2 && canAddOffice)" filterable clearable placeholder="请选择">
            <el-option
              v-for="item in outRefereeList"
              :key="item.id"
              :label="item.trueName"
              :value="item.id"/>
          </el-select>
        </el-col>
      </el-row>
    </div>
    <div v-permission="['league-game-referee-performance']" class="referee-box">
      <h3>裁判评价</h3>
      <div class="action">
        <el-button v-permission="['league-game-referee-performance-update']" @click="refereeRecordActionSave()">保存</el-button>
      </div>
      <el-row>
        <el-col :span="4">
          <span class="title">主裁1</span>
          <span class="title">奖惩结果</span>
          <el-input v-model="performance1.reword" type="textarea" rows="1"/>
          <span class="title">评价</span>
          <el-input v-model="performance1.remark" type="textarea" rows="6"/>
        </el-col>
        <el-col :span="1">&nbsp;</el-col>
        <el-col :span="4">
          <span class="title">主裁2</span>
          <span class="title">奖惩结果</span>
          <el-input v-model="performance2.reword" type="textarea" rows="1"/>
          <span class="title">评价</span>
          <el-input v-model="performance2.remark" type="textarea" rows="6"/>
        </el-col>
        <el-col :span="1">&nbsp;</el-col>
        <el-col :span="4">
          <span class="title">边裁1</span>
          <span class="title">奖惩结果</span>
          <el-input v-model="performance3.reword" type="textarea" rows="1"/>
          <span class="title">评价</span>
          <el-input v-model="performance3.remark" type="textarea" rows="6"/>
        </el-col>
        <el-col :span="1">&nbsp;</el-col>
        <el-col :span="4">
          <span class="title">边裁2</span>
          <span class="title">奖惩结果</span>
          <el-input v-model="performance4.reword" type="textarea" rows="1"/>
          <span class="title">评价</span>
          <el-input v-model="performance4.remark" type="textarea" rows="6"/>
        </el-col>
      </el-row>
      <!--<el-row>-->
      <!--<el-col :span="12">-->
      <!--<span class="title">申诉或处理原因</span>-->
      <!--<el-input type="textarea" rows="6" v-model="gameScore.judge" />-->
      <!--</el-col>-->
      <!--</el-row>-->
    </div>
  </div>
</template>

<script>
import permission from '@/directive/permission/index.js' // 权限判断指令
import checkPermission from '@/utils/permission' // 权限判断函数
import _ from 'lodash'
import { showMessage } from '@/utils'
import { adminGetGameScore, adminAddGameGoalEvent, adminUpdateGameGoalEvents, adminDeleteGameGoalEvents,
  adminUpdateGameGoalEvent, adminAddGamePenaltyEvent, adminUpdateGamePenaltyEvents, adminUpdateGamePenaltyEvent,
  adminDeleteGamePenaltyEvents, adminAddGameShootoutEvent, adminUpdateGameShootoutEvents, adminUpdateGameShootoutEvent,
  adminDeleteGameShootoutEvents, adminUpdateGameOffice, adminUpdateGameScore, exportGameData, addGoalieTimeItem, updateGoalieTimeItem, deleteGoalieTimeItem, getGoalieTimeItems } from '@/api/game'
import { getGroupTeam } from '@/api/match'
import { adminGetRefereeList, AdminUpdateGameRefereePerformances, updatePlayerStatusAndMvp } from '@/api/referee'
import GlobalFunc from '@/tbs/util/GlobalFunc'
import ObjectFunc from '@/tbs/util/ObjectFunc'

export default {
  name: 'LeagueGroupGameScore',
  directives: { permission },
  data() {
    return {
      homeGoalSelection: [],
      awayGoalSelection: [],
      homePenaltySelection: [],
      awayPenaltySelection: [],
      goalieTimeSelection: [],
      gameResult: [],
      gameScore: {},
      homePlayers: [],
      homeGoals: [],
      homePenalty: [],
      homeShoot: [],
      awayPlayers: [],
      awayGoals: [],
      awayPenalty: [],
      awayShoot: [],
      goalieTimes: [],
      refereeList: [],
      outRefereeList: [],
      office: {},
      performance1: { type: 0, pos: 0 },
      performance2: { type: 0, pos: 1 },
      performance3: { type: 1, pos: 0 },
      performance4: { type: 1, pos: 1 },
      canUpdateOffice: false,
      canAddOffice: false,
      qiquan: false,
      jiashi: false,
      gameId: '',
      homeTeamId: '',
      awayTeamId: '',
    }
  },
  computed: {
  },
  created() {
    const params = this.params = this.$route.params
    this.gameId = params.mid
    this.adminGetGameScore(params.mid)
    this.getRefereeList()
    this.getOutRefereeList()
    this.canUpdateOffice = this.checkPermission(['league-game-referee-update'])
    this.canAddOffice = this.checkPermission(['league-game-referee-add'])
  },
  methods: {
    checkPermission,
    refereeRecordActionSave() {
      // 整理数据
      const params = {}
      params.gameId = this.params.mid
      params.judge = this.gameScore.judge
      params.performances = []
      if (this.performance1.reword || this.performance1.remark) params.performances.push(this.performance1)
      if (this.performance2.reword || this.performance2.remark) params.performances.push(this.performance2)
      if (this.performance3.reword || this.performance3.remark) params.performances.push(this.performance3)
      if (this.performance4.reword || this.performance4.remark) params.performances.push(this.performance4)
      AdminUpdateGameRefereePerformances(params).then(response => {
        const data = response.data
        if (data) {
          showMessage('success', '保存成功')
        }
      })
    },
    handleRolesChange() {

    },
    statusChange(row) {
      if (!row.status) {
        row.mvp = false
      }
      row.status = !row.status
    },
    mvpChange(type, index) {
      if (type === 'home') {
        for (let i = 0; i < this.homePlayers.length; i++) {
          if (i !== index) this.homePlayers[i].mvp = false
        }
      } else {
        for (let i = 0; i < this.awayPlayers.length; i++) {
          if (i !== index) this.awayPlayers[i].mvp = false
        }
      }
    },
    saveHomeTeam() {
      let teamPlayerIds = ''
      let mvp = ''
      this.homePlayers.forEach(item => {
        if (item.status) {
          teamPlayerIds = teamPlayerIds + item.id + ','
        }
        if (item.mvp) {
          mvp = item.id
        }
      })
      // if (teamPlayerIds.length === 0) {
      //   this.$message.error('请至少检录一位运动员')
      // }
      if (teamPlayerIds.length > 0) {
        teamPlayerIds = teamPlayerIds.slice(0, teamPlayerIds.length - 1)
      }
      const params = {
        teamType: 'homeTeam',
        gameId: this.gameId,
        teamPlayerIds: teamPlayerIds,
        mvp: mvp
      }
      updatePlayerStatusAndMvp(params).then(res => {
        if (res) {
          this.$message.success('保存成功')
          this.getHomeTeamPlayers()
        }
      })
    },
    saveAwayTeam() {
      let teamPlayerIds = ''
      let mvp = ''
      this.awayPlayers.forEach(item => {
        if (item.status) {
          teamPlayerIds = teamPlayerIds + item.id + ','
        }
        if (item.mvp) {
          mvp = item.id
        }
      })
      // if (teamPlayerIds.length === 0) {
      //   this.$message.error('请至少检录一位运动员')
      // }
      if (teamPlayerIds.length > 0) {
        teamPlayerIds = teamPlayerIds.slice(0, teamPlayerIds.length - 1)
      }
      const params = {
        teamType: 'awayTeam',
        gameId: this.gameId,
        teamPlayerIds: teamPlayerIds,
        mvp: mvp
      }
      updatePlayerStatusAndMvp(params).then(res => {
        if (res) {
          this.$message.success('保存成功')
          this.getAwayTeamPlayers()
        }
      })
    },
    handleExport() {
      exportGameData(this.params.mid).then(response => {
        const data = response.data
        window.open(process.env.BJH_API + decodeURIComponent(data.url), '_blank')
      })
    },
    handleQiquanChange() {
      if (this.qiquan) {
        this.gameScore.qiquan = 1
      } else {
        this.gameScore.qiquan = 0
      }
      if (this.jiashi) {
        this.gameScore.jiashi = 1
      } else {
        this.gameScore.jiashi = 0
      }
      const h = this.gameResult[0]
      const a = this.gameResult[1]
      const params = {
        homeScore: this.gameScore.homeScore,
        awayScore: this.gameScore.awayScore,
        qiquan: this.gameScore.qiquan,
        gameId: this.gameScore.id,
        home1: h.first,
        home2: h.second,
        home3: h.third,
        home4: h.four,
        home5: h.five,
        away1: a.first,
        away2: a.second,
        away3: a.third,
        away4: a.four,
        away5: a.five,
        jiashi: this.gameScore.jiashi
      }
      adminUpdateGameScore(params)
    },
    goTeams() {
      this.$router.push({ name: 'LeagueGroupTeams', params: { id: 1, gid: 1 }})
    },
    goGames() {
      this.$router.push({ name: 'LeagueGroupGames', params: { id: 1, gid: 1 }})
    },
    onEdit(row, column, cell, event) {
      row.isEdit = true
    },
    /* goal start */
    onSubmit(row) { // TODO
      row.isEdit = false
      this.handleGoalSave(row) // 处理单个提交，包含创建和修改
    },
    onGoalSubmit(row) {
      row.isEdit = false
      this.handleGoalSave(row) // 处理单个提交，包含创建和修改
    },
    handleHomeGoalSelectionChange(val) { // checkbox 多选为删除服务，更新以isEdit为准
      this.homeGoalSelection = val
    },
    handleAwayGoalSelectionChange(val) {
      this.awayGoalSelection = val
    },
    handleGoalAdd(isHome) {
      let team = {}
      if (isHome) {
        team = this.gameScore.homeTeam
        this.homeGoals.push({ isEdit: true, teamId: team.id })
      } else {
        team = this.gameScore.awayTeam
        this.awayGoals.push({ isEdit: true, teamId: team.id })
      }
    },
    handleGoalSave(row) { // 单个（创建，修改）
      if (row) { // 处理当前单个
        if (row.id) {
          this.updateGoalEvents(row)
        } else {
          this.addGoalEvent(row)
        }
      }
      // 批量 由admin update 完成
    },
    // 点击"保存"肯定是更新操作，因为"对阵"是必选项
    // 处理批量
    handleGoalActionSave(isHome) {
      let goals = this.awayGoals
      let teamId = this.gameScore.awayTeam && this.gameScore.awayTeam.id
      if (isHome) {
        goals = this.homeGoals
        teamId = this.gameScore.homeTeam && this.gameScore.homeTeam.id
      }
      // TODO 全部提交 danger
      const arrs = _.filter(goals, function(item) {
        return item.isEdit
      })
      if (arrs && arrs < 1) {
        showMessage('warning', '无修改记录')
        return
      }
      const params = {
        gameId: this.params.mid,
        teamId: teamId
      }
      params.events = this.getUpdateGoalParams(goals, teamId)
      if (!params.events) {
        return
      }
      params.events = JSON.stringify(params.events)
      adminUpdateGameGoalEvents(params).then(response => {
        const data = response.data
        if (data) {
          showMessage('success', '修改成功')
          this.adminGetGameScore()
        }
      })
    },
    handleGoalDelete(isHome) {
      let selections = []
      if (isHome) {
        selections = this.homeGoalSelection
      } else {
        selections = this.awayGoalSelection
      }
      if (selections.length < 1) {
        showMessage('warning', '请选择操作记录')
        return
      }
      const ids = _.map(selections, 'id')
      this.deleteGoalEvents(ids)
    },
    vsChange(row) {
      this.handleGoalSave(row)
    },
    /* goal end */

    /* penalty stat */
    onPenaltySubmit(row) {
      row.isEdit = false
      this.handlePenaltySave(row) // 处理单个提交，包含创建和修改
    },
    handleHomePenaltySelectionChange(val) { // checkbox 多选为删除服务，更新以isEdit为准
      this.homePenaltySelection = val
    },
    handleAwayPenaltySelectionChange(val) {
      this.awayPenaltySelection = val
    },
    handlePenaltyAdd(isHome) {
      let team = {}
      if (isHome) {
        team = this.gameScore.homeTeam
        this.homePenalty.push({ isEdit: true, teamId: team.id })
      } else {
        team = this.gameScore.awayTeam
        this.awayPenalty.push({ isEdit: true, teamId: team.id })
      }
    },
    handlePenaltySave(row) { // 单个（创建，修改）
      if (row) { // 处理当前单个
        if (row.id) {
          this.updatePenaltyEvents(row)
        } else {
          this.addPenaltyEvent(row)
        }
      }
      // 批量 由admin update 完成
    },
    handlePenaltyActionSave(isHome) {
      let penalty = this.awayPenalty
      let teamId = this.gameScore.awayTeam && this.gameScore.awayTeam.id
      if (isHome) {
        penalty = this.homePenalty
        teamId = this.gameScore.homeTeam && this.gameScore.homeTeam.id
      }
      // TODO 全部提交 danger
      const arrs = _.filter(penalty, function(item) {
        return item.isEdit
      })
      if (arrs && arrs < 1) {
        showMessage('warning', '无修改记录')
        return
      }
      const params = {
        gameId: this.params.mid,
        teamId: teamId
      }
      params.events = this.getUpdatePenaltyParams(penalty, teamId)
      if (!params.events) {
        return
      }
      params.events = JSON.stringify(params.events)
      adminUpdateGamePenaltyEvents(params).then(response => {
        const data = response.data
        if (data) {
          showMessage('success', '修改成功')
          this.adminGetGameScore()
        }
      })
    },
    handlePenaltyDelete(isHome) {
      let selections = []
      if (isHome) {
        selections = this.homePenaltySelection
      } else {
        selections = this.awayPenaltySelection
      }
      if (selections.length < 1) {
        showMessage('warning', '请选择操作记录')
        return
      }
      const ids = _.map(selections, 'id')
      this.deletePenaltyEvents(ids)
    },
    /* penalty end */

    /* shoot stat */
    onShootSubmit(row) {
      row.isEdit = false
      this.handleShootSave(row) // 处理单个提交，包含创建和修改
    },
    handleHomeShootSelectionChange(val) { // checkbox 多选为删除服务，更新以isEdit为准
      this.homeShootSelection = val
    },
    handleAwayShootSelectionChange(val) {
      this.awayShootSelection = val
    },
    handleShootAdd(isHome) {
      let team = {}
      if (isHome) {
        team = this.gameScore.homeTeam
        this.homeShoot.push({ isEdit: true, teamId: team.id })
      } else {
        team = this.gameScore.awayTeam
        this.awayShoot.push({ isEdit: true, teamId: team.id })
      }
    },
    handleShootSave(row) { // 单个（创建，修改）
      if (row) { // 处理当前单个
        if (row.id) {
          this.updateShootEvents(row)
        } else {
          this.addShootEvent(row)
        }
      }
      // 批量 由admin update 完成
    },
    handleShootActionSave(isHome) {
      let shoot = this.awayShoot
      let teamId = this.gameScore.awayTeam && this.gameScore.awayTeam.id
      if (isHome) {
        shoot = this.homeShoot
        teamId = this.gameScore.homeTeam && this.gameScore.homeTeam.id
      }
      // TODO 全部提交 danger
      const arrs = _.filter(shoot, function(item) {
        return item.isEdit
      })
      if (arrs && arrs < 1) {
        showMessage('warning', '无修改记录')
        return
      }
      const params = {
        gameId: this.params.mid,
        teamId: teamId
      }
      params.events = this.getUpdateShootParams(shoot, teamId)
      if (!params.events) {
        return
      }
      params.events = JSON.stringify(params.events)
      adminUpdateGameShootoutEvents(params).then(response => {
        const data = response.data
        if (data) {
          showMessage('success', '修改成功')
          this.adminGetGameScore()
        }
      })
    },
    handleShootDelete(isHome) {
      let selections = []
      if (isHome) {
        selections = this.homeShootSelection
      } else {
        selections = this.awayShootSelection
      }
      if (selections.length < 1) {
        showMessage('warning', '请选择操作记录')
        return
      }
      const ids = _.map(selections, 'id')
      this.deleteShootEvents(ids)
    },
    vsShootChange(row) {
      this.handleShootSave(row)
    },
    /* shoot end */

    /* goalie time start */
    getJerseyNoByPlayer(playerId, teamId) {
        // console.log('getJerseyNoByPlayer', playerId, teamId)
        const homeTeam = this.gameScore.homeTeam
        const awayTeam = this.gameScore.awayTeam
        const isHome = homeTeam.id === teamId
        let players = []
        if (isHome) {
          players = this.homePlayers
        } else {
          players = this.awayPlayers
        }
        const obj = _.find(players, function(item) {
            return item.id === playerId
        })
        // console.log('obj.jerseyNo', obj && obj.jerseyNo)
        return obj && obj.jerseyNo
    },
    calcSecondsByString(timeStr) {
        if (timeStr && timeStr.length == 5 && timeStr.indexOf(':') > -1) {
            const timeArr = timeStr.split(':')
            return Number(timeArr[0]) * 60 + Number(timeArr[1])
        }
        else {
            return null
        }
    },
    calcSecondsByNumber(time) {
        if (isNaN(time)) {
            return ''
        }
        return ObjectFunc.pad(Math.floor(time/60), 2) + ':' + ObjectFunc.pad(time%60, 2)
    },
    formatGoalieTimeItem(row) {
        const item = { gameId: this.gameId }
        item.time = this.calcSecondsByString(row.time)
        item.homeTeamId = row.homeTeam
        item.awayTeamId = row.awayTeam
        if (row.homePlayer) {
            item.homePlayerId = this.getPlayerByJerseyNo(row.homePlayer, item.homeTeamId)
        }
        if (row.awayPlayer) {
            item.awayPlayerId = this.getPlayerByJerseyNo(row.awayPlayer, item.awayTeamId)
        }
        return item
    },
    renderGoalieTime(items) {
        const rows = []
        for (let i = 0; i < items.length; i++) {
            let item = items[i]
            rows.push({
                id: item.id,
                time: this.calcSecondsByNumber(item.time),
                homeTeam: item.homeTeamId,
                awayTeam: item.awayTeamId,
                homePlayer: this.getJerseyNoByPlayer(item.homePlayerId, item.homeTeamId),
                awayPlayer: this.getJerseyNoByPlayer(item.awayPlayerId, item.awayTeamId)
            })
        }
        console.log('@rows', JSON.stringify(rows))
        return rows
    },
    getGoalieTime() {
        // console.log('@gameId', this.gameId)
        getGoalieTimeItems({gameId: this.gameId}).then(res => {
            console.log('getGoalieTimeItems', res)
            this.goalieTimes = this.renderGoalieTime(res)
        })
    },
    addGoalieTime(row) {
        console.log('addGoalieTime', row)
        const item = this.formatGoalieTimeItem(row)
        addGoalieTimeItem(item).then(res => {
            console.log('addGoalieTimeItem res', res)
            row.id = res.affectedId
        })
    },
    updateGoalieTime(row) {
        console.log('updateGoalieTime', row)
        const item = this.formatGoalieTimeItem(row)
        updateGoalieTimeItem({id: row.id}, item).then(res => {
            console.log('updateGoalieTimeItem res', res)
        })
    },
    handleGoalieTimeAdd() {
        const homeTeamId = this.gameScore.homeTeam && this.gameScore.homeTeam.id
        const awayTeamId = this.gameScore.awayTeam && this.gameScore.awayTeam.id
        const item = {
            isEdit: true,
            homeTeam: homeTeamId,
            awayTeam: awayTeamId
        }
        if (this.goalieTimes.length == 0) {
            item.time = '00:00'
        }
        this.goalieTimes.push(item)
    },
    handleGoalieTimeSubmit(row) {
        if (row) {
            if (row.id) {
                this.updateGoalieTime(row)
            }
            else {
                this.addGoalieTime(row)
            }
        }
    },
    handleGoalieTimeDelete() {
        if (this.goalieTimeSelection.length < 1) {
            showMessage('warning', '请选择操作记录')
            return
        }
        // delete the selected rows
        const ids = _.map(this.goalieTimeSelection, 'id')
        console.log('delete goalie time rows', ids)
        deleteGoalieTimeItem(ids).then(res => {
            console.log('deleteGoalieTimeItem', res)
            this.adminGetGameScore()
        })
    },
    handleGoalieTimeSelectionChange(val) {
        this.goalieTimeSelection = val
    },
    onGoalieTimeSubmit(row) {
        // console.log('submit goalie time row', row.time)
        GlobalFunc.delayExecute(this, function() {
            if (row.time.length < 5) {
                return
            }
            else if (!(row.time.indexOf(":") > -1 && row.time.length == 5)) {
                showMessage('warning', '请输入正确时间格式')
                return
            }
            else {
                this.handleGoalieTimeSubmit(row)
            }
        }, 2000)
    },
    /* goaile time end */

    resetData() {
      this.homeGoals = []
      this.homePenalty = []
      this.homeShoot = []
      this.awayGoals = []
      this.awayPenalty = []
      this.awayShoot = []
    },
    adminGetGameScore() {
      adminGetGameScore(this.params.mid).then(response => {
        this.resetData()
        const data = response.data
        const stages = data.stages
        const gameScore = this.gameScore = data.game
        this.homeTeamId = gameScore.homeTeam.id
        this.awayTeamId = gameScore.awayTeam.id
        this.getHomeTeamPlayers()
        this.getAwayTeamPlayers()
        this.qiquan = gameScore.qiquan > 0
        this.jiashi = gameScore.jiashi > 0
        this.gameResult = [
          { name: gameScore.homeTeam.name, first: stages.home1, second: stages.home2,
            third: stages.home3, four: stages.home4, five: stages.home5, total: stages.home },
          { name: gameScore.awayTeam.name, first: stages.away1, second: stages.away2,
            third: stages.away3, four: stages.away4, five: stages.away5, total: stages.away }
        ]
        const homeTeam = gameScore.homeTeam
        const homeGoals = homeTeam.goals
        for (let i = 0; i < homeGoals.length; i++) {
          const obj = {
            id: homeGoals[i].id,
            time: homeGoals[i].time,
            player: homeGoals[i].player && homeGoals[i].player.jerseyNo,
            other1: homeGoals[i].other1 && homeGoals[i].other1.jerseyNo,
            other2: homeGoals[i].other2 && homeGoals[i].other2.jerseyNo,
            goalkeeper: homeGoals[i].goalkeeper && homeGoals[i].goalkeeper.jerseyNo,
            duizhen: homeGoals[i].duizhen,
            teamId: homeGoals[i].teamId,
            isEdit: false
          }
          this.homeGoals.push(obj)
        }
        const homePenalty = homeTeam.penalties
        for (let i = 0; i < homePenalty.length; i++) {
          const obj = {
            id: homePenalty[i].id,
            type: homePenalty[i].type,
            begin: homePenalty[i].begin,
            end: homePenalty[i].end,
            minutes: homePenalty[i].minutes,
            player: homePenalty[i].player && homePenalty[i].player.jerseyNo,
            teamId: homePenalty[i].teamId,
            isEdit: false
          }
          this.homePenalty.push(obj)
        }
        const homeShootouts = homeTeam.shootouts
        for (let i = 0; i < homeShootouts.length; i++) {
          const obj = {
            id: homeShootouts[i].id,
            player: homeShootouts[i].player && homeShootouts[i].player.jerseyNo,
            goalkeeper: homeShootouts[i].goalkeeper && homeShootouts[i].goalkeeper.jerseyNo,
            goal: homeShootouts[i].goal,
            win: homeShootouts[i].win,
            teamId: homeShootouts[i].teamId,
            isEdit: false
          }
          this.homeShoot.push(obj)
        }

        const awayTeam = gameScore.awayTeam
        const awayGoals = awayTeam.goals
        for (let i = 0; i < awayGoals.length; i++) {
          const obj = {
            id: awayGoals[i].id,
            time: awayGoals[i].time,
            player: awayGoals[i].player && awayGoals[i].player.jerseyNo,
            other1: awayGoals[i].other1 && awayGoals[i].other1.jerseyNo,
            other2: awayGoals[i].other2 && awayGoals[i].other2.jerseyNo,
            goalkeeper: awayGoals[i].goalkeeper && awayGoals[i].goalkeeper.jerseyNo,
            duizhen: awayGoals[i].duizhen,
            teamId: awayGoals[i].teamId,
            isEdit: false
          }
          this.awayGoals.push(obj)
        }
        const awayPenalty = awayTeam.penalties
        for (let i = 0; i < awayPenalty.length; i++) {
          const obj = {
            id: awayPenalty[i].id,
            type: awayPenalty[i].type,
            begin: awayPenalty[i].begin,
            end: awayPenalty[i].end,
            minutes: awayPenalty[i].minutes,
            player: awayPenalty[i].player && awayPenalty[i].player.jerseyNo,
            teamId: awayPenalty[i].teamId,
            isEdit: false
          }
          this.awayPenalty.push(obj)
        }
        const awayShootouts = awayTeam.shootouts
        for (let i = 0; i < awayShootouts.length; i++) {
          const obj = {
            id: awayShootouts[i].id,
            player: awayShootouts[i].player && awayShootouts[i].player.jerseyNo,
            goalkeeper: awayShootouts[i].goalkeeper && awayShootouts[i].goalkeeper.jerseyNo,
            goal: awayShootouts[i].goal,
            win: awayShootouts[i].win,
            teamId: awayShootouts[i].teamId,
            isEdit: false
          }
          this.awayShoot.push(obj)
        }
        this.office = data.office
        // 格式一下 裁判的表现
        for (const i in data.performances) {
          const item = data.performances[i]
          if (item.type === 0) {
            if (item.pos !== 0) {
              this.performance2 = item
            } else {
              this.performance1 = item
            }
          } else if (item.type === 1) {
            if (item.pos !== 0) {
              this.performance4 = item
            } else {
              this.performance3 = item
            }
          }
        }
        const self = this
        setTimeout(function() {
            self.getGoalieTime()
        }, 2000)
        
      })
    },
    getHomeTeamPlayers() {
      const params = {
        teamId: this.homeTeamId,
        groupId: this.params.gid,
        gameId: this.gameId
      }
      getGroupTeam(params).then(response => {
        const data = response.data
        //        this.homePlayers = data.team && data.team.players
        const guard = _.filter(data.team.players, function(item) {
          return item.position === '守门员'
        })
        const other = _.filter(data.team.players, function(item) {
          return item.position !== '守门员'
        })
        this.homePlayers = _.concat(guard, other)
        this.homePlayers.forEach(item => {
          item.status = item.status === 0
        })
        this.homePlayers.forEach(item => {
          item.mvp = item.mvp && item.mvp === 1
        })
        console.log(this.homePlayers)
      })
    },
    getAwayTeamPlayers() {
      const params = {
        teamId: this.awayTeamId,
        groupId: this.params.gid,
        gameId: this.gameId
      }
      getGroupTeam(params).then(response => {
        const data = response.data
        //        this.awayPlayers = data.team && data.team.players
        const guard = _.filter(data.team.players, function(item) {
          return item.position === '守门员'
        })
        const other = _.filter(data.team.players, function(item) {
          return item.position !== '守门员'
        })
        this.awayPlayers = _.concat(guard, other)
        this.awayPlayers.forEach(item => {
          item.status = item.status === 0
        })
        this.awayPlayers.forEach(item => {
          item.mvp = item.mvp && item.mvp === 1
        })
      })
    },
    // goal
    addGoalEvent(event) {
      const teamId = event.teamId
      const arr = this.getUpdateGoalParams([event], teamId)
      if (!arr) {
        return
      }
      const params = {
        gameId: this.params.mid,
        teamId: teamId,
        player: arr[0].player,
        other1: arr[0].other1,
        other2: arr[0].other2,
        goalkeeper: arr[0].goalkeeper,
        time: event.time,
        duizhen: event.duizhen
      }
      adminAddGameGoalEvent(params).then(response => {
        const data = response.data
        if (data) {
          showMessage('success', '创建成功')
          this.adminGetGameScore()
        }
      })
    },
    updateGoalEvents(event) {
      const arr = this.getUpdateGoalParams([event], event.teamId)
      if (!arr) {
        return
      }
      const params = {
        gameId: this.params.mid,
        teamId: event.teamId,
        id: event.id,
        player: arr[0].player,
        other1: arr[0].other1,
        other2: arr[0].other2,
        goalkeeper: arr[0].goalkeeper,
        time: event.time,
        duizhen: event.duizhen
      }
      adminUpdateGameGoalEvent(params).then(response => {
        const data = response.data
        if (data) {
          showMessage('success', '修改成功')
          this.adminGetGameScore()
        }
      })
    },
    deleteGoalEvents(ids) {
      const params = {
        ids: ids.join()
      }
      adminDeleteGameGoalEvents(params).then(response => {
        const data = response.data
        if (data) {
          showMessage('success', '删除成功')
          this.adminGetGameScore()
        }
      })
    },
    getUpdateGoalParams(paramArr, teamId) {
      const ret = []
      for (let i = 0; i < paramArr.length; i++) {
        const obj = {}
        obj.id = paramArr[i].id
        if (paramArr[i].player) {
          obj.player = this.getPlayerByJerseyNo(paramArr[i].player, teamId)
          if (!obj.player) {
            showMessage('error', '球员号码填写错误！')
            return
          }
        }
        if (paramArr[i].other1) {
          obj.other1 = this.getPlayerByJerseyNo(paramArr[i].other1, teamId)
        }
        if (paramArr[i].other2) {
          obj.other2 = this.getPlayerByJerseyNo(paramArr[i].other2, teamId)
        }
        if (paramArr[i].goalkeeper) {
          obj.goalkeeper = this.getPlayerByJerseyNo(paramArr[i].goalkeeper, teamId, 1)
          if (!obj.goalkeeper) {
            showMessage('error', '守门员号码填写错误！')
            return
          }
        }
        obj.time = paramArr[i].time
        obj.duizhen = paramArr[i].duizhen
        ret.push(obj)
      }
      return ret
    },
    // penalty
    addPenaltyEvent(event) {
      const teamId = event.teamId
      const arr = this.getUpdatePenaltyParams([event], teamId)
      if (!arr) {
        return
      }
      const params = {
        gameId: this.params.mid,
        teamId: teamId,
        player: arr[0].player,
        type: event.type,
        begin: event.begin,
        end: event.end,
        minutes: event.minutes
      }
      adminAddGamePenaltyEvent(params).then(response => {
        const data = response.data
        if (data) {
          showMessage('success', '创建成功')
          this.adminGetGameScore()
        }
      })
    },
    updatePenaltyEvents(event) {
      const arr = this.getUpdatePenaltyParams([event], event.teamId)
      if (!arr) {
        return
      }
      const params = {
        gameId: this.params.mid,
        teamId: event.teamId,
        id: event.id,
        player: arr[0].player,
        type: event.type,
        begin: event.begin,
        end: event.end,
        minutes: event.minutes
      }
      adminUpdateGamePenaltyEvent(params).then(response => {
        const data = response.data
        if (data) {
          showMessage('success', '修改成功')
          this.adminGetGameScore()
        }
      })
    },
    deletePenaltyEvents(ids) {
      const params = {
        ids: ids.join()
      }
      adminDeleteGamePenaltyEvents(params).then(response => {
        const data = response.data
        if (data) {
          showMessage('success', '删除成功')
          this.adminGetGameScore()
        }
      })
    },
    getUpdatePenaltyParams(paramArr, teamId) {
      const ret = []
      for (let i = 0; i < paramArr.length; i++) {
        const obj = {}
        obj.id = paramArr[i].id
        if (paramArr[i].player) {
          obj.player = this.getPlayerByJerseyNo(paramArr[i].player, teamId)
          if (!obj.player) {
            showMessage('error', '球员号码填写错误！')
            return
          }
        }
        obj.type = paramArr[i].type
        obj.begin = paramArr[i].begin
        obj.end = paramArr[i].end
        obj.minutes = paramArr[i].minutes
        ret.push(obj)
      }
      return ret
    },
    // shoot
    addShootEvent(event) {
      const teamId = event.teamId
      const arr = this.getUpdateShootParams([event], teamId)
      if (!arr) {
        return
      }
      const params = {
        gameId: this.params.mid,
        teamId: teamId,
        player: arr[0].player,
        goalkeeper: arr[0].goalkeeper,
        goal: event.goal,
        win: event.win
      }
      adminAddGameShootoutEvent(params).then(response => {
        const data = response.data
        if (data) {
          showMessage('success', '创建成功')
          this.adminGetGameScore()
        }
      })
    },
    updateShootEvents(event) {
      const arr = this.getUpdateShootParams([event], event.teamId)
      if (!arr) {
        return
      }
      const params = {
        gameId: this.params.mid,
        teamId: event.teamId,
        id: event.id,
        player: arr[0].player,
        goalkeeper: arr[0].goalkeeper,
        goal: event.goal,
        win: event.win
      }
      adminUpdateGameShootoutEvent(params).then(response => {
        const data = response.data
        if (data) {
          showMessage('success', '修改成功')
          this.adminGetGameScore()
        }
      })
    },
    deleteShootEvents(ids) {
      const params = {
        ids: ids.join()
      }
      adminDeleteGameShootoutEvents(params).then(response => {
        const data = response.data
        if (data) {
          showMessage('success', '删除成功')
          this.adminGetGameScore()
        }
      })
    },
    getUpdateShootParams(paramArr, teamId) {
      const ret = []
      for (let i = 0; i < paramArr.length; i++) {
        const obj = {}
        obj.id = paramArr[i].id
        if (paramArr[i].player) {
          obj.player = this.getPlayerByJerseyNo(paramArr[i].player, teamId)
          if (!obj.player) {
            showMessage('error', '球员号码填写错误！')
            return
          }
        }
        if (paramArr[i].goalkeeper) {
          obj.goalkeeper = this.getPlayerByJerseyNo(paramArr[i].goalkeeper, teamId, 1)
          if (!obj.goalkeeper) {
            showMessage('error', '守门员号码填写错误！')
            return
          }
        }
        obj.goal = paramArr[i].goal
        obj.win = paramArr[i].win
        ret.push(obj)
      }
      return ret
    },
    refereeActionSave() {
      const params = {
        gameId: this.params.mid,
        supervisor: this.office.supervisor,
        mainReferee1: this.office.mainReferee1,
        mainReferee2: this.office.mainReferee2,
        linesman1: this.office.linesman1,
        linesman2: this.office.linesman2,
        refereeSupervisor: this.office.refereeSupervisor,
        timer: this.office.timer,
        recorder: this.office.recorder,
        announcer: this.office.announcer,
        refereeRecorder1: this.office.refereeRecorder1,
        refereeRecorder2: this.office.refereeRecorder2,
        assist1: this.office.assist1,
        assist2: this.office.assist2,
        assist3: this.office.assist3

      }
      adminUpdateGameOffice(params).then(response => {
        const data = response.data
        if (data) {
          showMessage('success', '保存成功')
        }
      })
    },
    getRefereeList() {
      const params = {
        pageNum: 1,
        pageSize: 9999,
        inField: 1
      }
      adminGetRefereeList(params).then(response => {
        const data = response.data
        this.refereeList = data.list
      })
    },
    getOutRefereeList() {
      const params = {
        pageNum: 1,
        pageSize: 9999,
        inField: 0
      }
      adminGetRefereeList(params).then(response => {
        const data = response.data
        this.outRefereeList = data.list
      })
    },
    // common
    getPlayerByJerseyNo(number, teamId, flag) {
      const homeTeam = this.gameScore.homeTeam
      const awayTeam = this.gameScore.awayTeam
      const isHome = homeTeam.id === teamId
      let players = []
      if (flag) {
        if (isHome) {
          players = this.awayPlayers
        } else {
          players = this.homePlayers
        }
      } else {
        if (isHome) {
          players = this.homePlayers
        } else {
          players = this.awayPlayers
        }
      }
      const obj = _.find(players, function(item) {
        return item.jerseyNo === number
      })
      return obj && obj.id
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
.score-container {
  margin: 30px;
  .result {
    min-width: 760px;
  }
}

.score-container .el-input--small .el-input__inner {
  padding: 0;
  height: 24px;
}

.score-container .team-score {
  margin-top: 30px;
}

.score-container .team-action {
  position: relative;
  float: left;
}
.score-container .team-action .action {
    position: absolute;
    right: 10px;
    top: 20px;
}
.score-container .team-action .el-input__suffix-inner {
  position: relative;
  right: -6px;
  top: 0;
}
.score-container .team-action .el-table .cell {
  padding-left: 5px;
  padding-right: 5px;
}
.score-container .referee-box {
  padding: 20px 0 30px 0;
  position: relative;
}
.score-container .referee-box .action {
  position: absolute;
  top: 30px;
  left: 100px;
}
.score-container .referee-box .title {
  padding-top: 10px;
  padding-bottom: 10px;
  display: block;
}

.qiquanBox {
  float: left;
  padding-left: 30px;
  .title {
    color: #909399;
    font-size: 12px;
    font-weight: bold;
    padding: 6px 0;
  }
}
</style>
